/* eslint-disable @typescript-eslint/no-explicit-any */
import Head from 'next/head'
import { useLayoutData } from '../../utils/contexts/LayoutContext'
import { LayoutProps } from '../../design/common/Layouts'
import AutoraLayout from './templates/AutoraTemplate/AutoraLayout'
import { PartnerSiteComponent_HelyszinItem, PartnerSiteGraphVM } from '../../client/swaggerClient'
import { Box, Container, Typography, styled } from '@mui/material'
import CastroLayout from './templates/CastroTemplate/CastroLayout'
import { common } from '@mui/material/colors'

export interface HelyszinIconProps {
  data?: PartnerSiteComponent_HelyszinItem
  type: 'phones' | 'emails' | 'openingHours' | 'webs' | 'address'
}

export interface Day {
  [key: number]: string
}

export const Weekdays: Day = {
  1: 'Hétfő',
  2: 'Kedd',
  3: 'Szerda',
  4: 'Csütürtök',
  5: 'Péntek',
  6: 'Szombat',
  7: 'Vasárnap',
}

export const LoadingScreenStyle = {
  alignItems: 'center',
  background: common['white'],
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  position: 'fixed',
  width: '100%',
  zIndex: 10000,
}

const PartnerPortalDisabledContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[900],
  marginTop: "5rem",
  padding: "4rem 2rem"
}))

// Ide kell betölteni a partnerPortalTemplates.ts fájl alapján a template-ek layout-ját
// az alapértelmezett layout az Autora
const getPartnerPortalLayout = (children: string | JSX.Element | (string | JSX.Element)[], templateId?: string) => {
  switch (templateId) {
    case "AutoraTemplate":
      return <AutoraLayout>{children}</AutoraLayout>
      break
    case "CastroTemplate":
      return <CastroLayout>{children}</CastroLayout>
      break
    default:
      return <AutoraLayout>{children}</AutoraLayout>
  }
}

export const colorSetter = (data?: PartnerSiteGraphVM, colorType?: string) => {
  const color = data?.content?.templateProperties?.items?.find((item) => {
    if (item.key === colorType) return item.value && item.value !== "" ? item.value : null
  })

  return color?.value ?? null
}

export const componentShowInMenu = (id?: string, partnerSiteFull?: PartnerSiteGraphVM) => partnerSiteFull?.components && id && partnerSiteFull?.components[id].some((component) => component.enabled && component.showInMenu)
export const isSubNameAvailable = (partnerSiteFull?: PartnerSiteGraphVM) => partnerSiteFull?.partnerSite?.subName && partnerSiteFull?.partnerSite?.subName !== "";
export const createSlug = (string: string | undefined) => 
  string?.toString().toLowerCase().trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/&/g, '-and-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');

export const topBarAvailable = (partnerSiteFull: PartnerSiteGraphVM | undefined) => partnerSiteFull?.content?.topBar?.items && partnerSiteFull.content.topBar.items.length > 0
export const topBarHasRightData = (partnerSiteFull: PartnerSiteGraphVM | undefined) => partnerSiteFull?.content?.topBar?.items?.find((items) => items.rightSide === true)
export const topBarHasLeftData = (partnerSiteFull: PartnerSiteGraphVM | undefined) => partnerSiteFull?.content?.topBar?.items?.find((items) => items.rightSide === false)

const PartnerPortalLayout = ({ children }: LayoutProps) => {
  const { error, partnerSiteFull } = useLayoutData()
  const favicon = partnerSiteFull?.content?.favicon && partnerSiteFull?.content?.favicon !== "" ? partnerSiteFull?.content?.favicon : null
  const data = partnerSiteFull?.content?.favicon?.split(';')[0];
  const type = data?.split(':')[1];
  const showDescriptionMeta = !error && partnerSiteFull?.content?.htmlDescription && partnerSiteFull?.content?.htmlDescription !== ""
  const hasHtmlTitle = partnerSiteFull?.content?.htmlTitle && partnerSiteFull?.content?.htmlTitle !== ""

  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        {showDescriptionMeta ? 
          <meta name="description" content={partnerSiteFull?.content?.htmlDescription}/>
        : undefined}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{!error ? hasHtmlTitle ? partnerSiteFull?.content?.htmlTitle : partnerSiteFull?.partnerSite?.name : `Racing Bazár PartnerPortál - ${(error as any)?.UIMessage ?? 'Ez az oldal nem létezik.'}`}</title>
        <link rel="icon" type={`${favicon ? type : 'image/x-icon'}`} href={favicon ?? '/partnerPortalFavicon.ico'} sizes="16x16"></link>
      </Head>

      {!error ? getPartnerPortalLayout(children, partnerSiteFull?.content?.templateId) : (
        <>
          <PartnerPortalDisabledContainer>
            <Container maxWidth={"xl"}>
              <Typography variant="h2">Racing Bazár PartnerPortál</Typography>
              <Typography variant="h5">
                {(error as any)?.UIMessage ?? 'Ez az oldal nem létezik.'}
              </Typography>
            </Container>
          </PartnerPortalDisabledContainer>
        </>
      )}
    </>
  )
}

export default PartnerPortalLayout
